import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { IconType } from "react-icons";
import "../styles/TextCard.css";

interface TextCardProps {
  title: string;
  date: string;
  reference?: string; 
  description: string;
  status?: string;
  onClick?: () => void;
}

const calendarIcon: { icon: IconType }[] = [{ icon: FaCalendarAlt }];

const TextCard: React.FC<TextCardProps> = ({ title, date, reference, description, status, onClick }) => {
  return (
    <div className="text-card">
      <div className="textcard-header">
        <h3 className="textcard-title">{title}</h3>

        <div className="textcard-header-right">
          {reference && <span className="textcard-ref">Ref: {reference}</span>}          
        </div>
      </div>

      <div className="textcard-body">
        <div className="textcard-date">
          {calendarIcon.map((d, i) => {
            const Icon = d.icon as React.ComponentType<{ className?: string }>;
            return (
              <div className="icon" key={i}>
                <Icon className="calendar-icon" />
              </div>
            );
          })}
          <span>Clôturé le : {date}</span>
        </div>

          {status && (
            <span className={`textcard-status ${status.toLowerCase()}`}>
              {status === "resultat_de_marche"
                ? "Attribué"
                : status === "cloture"
                ? "Clôturé"
                : status
                    .replace(/_/g, " ")
                    .toLowerCase()
                    .replace(/^\w/, c => c.toUpperCase())
              }
            </span>
          )}
        
        <br /><br />
        <p className="textcard-desc">{description}</p>

        <button className="textcard-btn" onClick={onClick}>
          En savoir plus
        </button>
      </div>
    </div>
  );
};

export default TextCard;